<template>
    <div :class="bootstrapClass[lowerCaseTenantDomainTheme]">
        <slot></slot>
    </div>
</template>

<script>
import {tenantDomainTheme} from "../../../../../mixins/tenantDomainTheme";

export default {
    name: 'ThemedBootstrapCardFooter',

    mixins: [
        tenantDomainTheme,
    ],

    data() {
        return {
            bootstrapClass: {
                artificialreason: 'panel-footer',
                assan: 'card-footer',
                eventrac: 'box-footer',
            },
        }
    },
}
</script>



// WEBPACK FOOTER //
// src/Assets/components/AAA_TO_REFACTOR/Bootstrap/Bootstrap/Card/ThemedBootstrapCardFooter.vue